import { Box, IconButton, Image, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { ChristmasPickProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import ChristmasPickImage from '../assets/images/ChristmasPick.png';
import SparklingLeavesImage from '../assets/images/SparklingLeaves.png';
import AlmondAndFlowerImage from '../assets/images/Almond&Flower.png';
import PowderedSheaImage from '../assets/images/PowderedShea.png';
import RoseVinePeachImage from '../assets/images/RoseVinePeach.png';
import Slider from 'react-slick';
import { Eclipse } from '../Icons/Eclipse';
import { InstructionsLeftArrow } from '../Icons/InstructionsLeftArrow';
import { InstructionsRightArrow } from '../Icons/InstructionsRightArrow';
import { dispatchCTAClickObject } from '../Analytics';

export interface ChristmasPicksImage {
  image: string;
  en: {
    title: string;
    description: string;
  };
  ar: {
    title: string;
    description: string;
  };
}

const ChristmasPick = ({ activeLocale, active, setActive }: ChristmasPickProps) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [slider, setSlider] = useState<any>();
  const [activeImageIndex, setActiveImageIndex] = useState({ oldIndex: 0, newIndex: 0 });

  const christmasPicks: ChristmasPicksImage[] = [
    {
      image: ChristmasPickImage,
      en: {
        title: 'Our Holiday Picks',
        description:
          'Celebrate with your nearest and dearest and pick your favorites from our limited-edition collection that includes...',
      },
      ar: {
        title: 'خياراتنا لك في موسم الأعياد',
        description: '...احتفل مع أحبائك وقم باختيار منتجاتك المفضلة من مجموعتنا المحدودة التي تتضمّن',
      },
    },
    {
      image: SparklingLeavesImage,
      en: {
        title: 'Sparkling Leaves',
        description:
          'Range inspired by olive tree leaves with fresh notes of fruits sparkling against the ward backdrop of woody shea nut.',
      },
      ar: {
        title: 'الأوراق البرّاقة',
        description:
          '.مجموعة مستوحاة من أوراق أشجار الزيتون مع نفحات منعشة من الفاكهة البرّاقة على خلفية ثمار الشيا الخشبية',
      },
    },
    {
      image: AlmondAndFlowerImage,
      en: {
        title: 'Almonds & Flowers',
        description: 'Unexpectedly sensational - The first ever limited edition from the most loved Almond range.',
      },
      ar: {
        title: 'اللوز والزهور',
        description: '.المجموعة المحدودة الأولى على الإطلاق من مجموعة اللوز المحبوبة، تحاكي الحواس بشكل غير متوقع',
      },
    },
    {
      image: PowderedSheaImage,
      en: {
        title: 'Powdered Shea',
        description:
          'The soft, comforting scent inspired by olive branches. Shea nut meets olive tree wood, for powdery, creamy facets that mingle with green, delicate notes.',
      },
      ar: {
        title: 'الشيا برائحة بودرية',
        description:
          '.الرائحة الناعمة والمريحة المستوحاة من أغصان الزيتون. تلتقي نفحات ثمار الشيا برائحة خشب أشجار الزيتون لتكشف عن جوانب خفيفة وكريمية تمتزج بالنفحات الطبيعية والرقيقة',
      },
    },
    {
      image: RoseVinePeachImage,
      en: {
        title: 'Rose Vine Peach',
        description:
          'For this limited edition, the gentle delight of rose meets the succulent delectation of peach - and the result is pure joy. ',
      },
      ar: {
        title: 'الورد وخوخ الكرمة',
        description: '.في هذه المجموعة المحدودة، تلتقي نعومة الورد بإشراقة الخوخ لتمنحك شعوراً مطلقاً بالسعادة',
      },
    },
  ];

  const nextSlide = () => {
    dispatchCTAClickObject('loccitane', 'button', 'christmasPick', 'next', '');
    slider.slickNext();
  };

  const prevSlide = () => {
    dispatchCTAClickObject('loccitane', 'button', 'christmasPick', 'prev', '');
    slider.slickPrev();
  };

  const settings = {
    speed: 500,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setActiveImageIndex({ oldIndex: oldIndex, newIndex: newIndex });
    },
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['80vw', '360px', '400px', '900px', '950px']}
        height={['500px', '550px', '600px', '450px', '500px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          flexDirection={['column', 'column', 'column', 'row', 'row']}
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Box w={['100%', '100%', '100%', '425px', '450px']} h={['215px', '250px', '275px', '390px', '440px']}>
            <Slider ref={(slider) => setSlider(slider)} {...settings}>
              {christmasPicks?.map((image: ChristmasPicksImage, index: number) => (
                <Image
                  key={index}
                  w={['100%', '100%', '100%', '450px', '450px']}
                  h={['215px', '250px', '275px', '440px', '440px']}
                  objectFit="cover"
                  src={image.image}
                />
              ))}
            </Slider>
          </Box>

          <Box
            textAlign="center"
            w={['100%', '450px', '100%', '450px', '450px']}
            h={['255px', '250px', '275px', '450px', '450px']}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              h={['20px', '25px', '20px', '35px', '35px']}
              fontSize={['13px', '15px', '15px', '20px', '20px']}
              fontFamily={activeLocale.includes('ar') ? 'GETwoLight' : 'RalewayMedium'}
              color="#FDC506"
              textTransform="uppercase"
            >
              {activeImageIndex.newIndex !== 0 ? (activeLocale.includes('ar') ? 'جديد' : 'New') : ''}
            </Text>

            <Box
              h={['140px', '140px', '140px', '210px', '210px']}
              mb={['5px ', '5px', '5px', '20px', '20px']}
              display="flex"
              justifyContent="space-around"
              flexDirection="column"
            >
              <Text
                m="0 auto"
                fontSize={['23px', '30px', '30px', '40px', '40px']}
                lineHeight={['23px', '30px', '30px', '40px', '40px']}
                w={activeImageIndex.newIndex === 2 ? ['200px'] : ['200px', '200px', '300px']}
                fontFamily={
                  activeLocale.includes('ar')
                    ? 'GETwoLight'
                    : activeImageIndex.newIndex === 0
                    ? 'LoccitaneRegular'
                    : 'GuyonGazeboRegular'
                }
                fontWeight="500"
                color={activeImageIndex.newIndex === 0 ? 'black' : '#FDC506'}
              >
                {activeLocale.includes('ar')
                  ? christmasPicks[activeImageIndex.newIndex].ar.title
                  : christmasPicks[activeImageIndex.newIndex].en.title}
              </Text>
              <Text
                m="0 auto"
                w={['90%', '280px', '320px', '330px', '330px']}
                fontSize={['13px', '15px', '15px', '20px', '20px']}
                fontFamily={activeLocale.includes('ar') ? 'GETwoLight' : 'RalewayMedium'}
              >
                {activeLocale.includes('ar')
                  ? christmasPicks[activeImageIndex.newIndex].ar.description
                  : christmasPicks[activeImageIndex.newIndex].en.description}
              </Text>
            </Box>

            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              alignItems="center"
              h="auto"
              mb={['10px', '10px', '15px', '20px', '20px']}
            >
              {christmasPicks.map((image: ChristmasPicksImage, index: number) => (
                <Eclipse
                  borderRadius="100%"
                  key={image.image}
                  m="0px 5px"
                  boxSize={[2, 2, 3]}
                  strokeWidth="2"
                  stroke={activeImageIndex.newIndex === index ? '#FFD220' : '#D9D9D9'}
                  fill={activeImageIndex.newIndex === index ? '#FFD220' : 'white'}
                  onClick={() => {
                    slider.slickGoTo(index);
                  }}
                  cursor="pointer"
                />
              ))}
            </Box>

            <Box
              w={['150px', '170px', '170px', '170px', '170px']}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <IconButton
                variant="outline"
                aria-label="Move Left"
                onClick={prevSlide}
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                borderRadius="0px"
                icon={<InstructionsLeftArrow boxSize={[6, 8, 10]} />}
              />

              <IconButton
                variant="outline"
                aria-label="Move Left"
                onClick={nextSlide}
                height={['30px', '40px', '40px', '40px', '40px']}
                width={['70px', '80px', '80px', '80px', '80px']}
                borderRadius="0px"
                icon={<InstructionsRightArrow boxSize={[6, 8, 10]} />}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};
export default ChristmasPick;
